import React, { Component } from "react";
import { Row, Col, Steps, Popover } from "antd";
import { connect } from "react-redux";
import { AuthAction } from "../../store/actions";
import Register from "./register";
import Profile from "./profile";
import Personalize from "./personalize";
import AddPlant from "./Addplant";
import BuildMain from './buildMain'

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      userInfo: {},
    };
  }
  userData = (data) => {
    this.setState({
      userInfo: data,
    });
  };
  render() {
    const { count } = this.state;
    console.log('count==>',count)
    return (
      <Row>
        <Col span={24}>
          {count === 0 && (
            <Register
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              userData={this.userData}
            />
          )}

          {count === 1 && (
            <Profile
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              user={this.state.userInfo}
            />
          )}
          {count === 2 && (
            <AddPlant
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
          {count === 3 && (
            <Personalize
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
          {count===4&&<BuildMain/>}
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signup: (payload, cb) => dispatch(AuthAction.SignUp(payload, cb)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
